module.exports = "/components/components/emailSuggestionComponent-ba8816.html";